import { companyNotComfirmReducer } from "../reducer/CompanyNotComfirmReducer";

export const reducer = companyNotComfirmReducer;